<template>
	<div class="EditAddTerminal">
		<el-form v-loading="loadingPage" :model="ruleForm" ref="ruleForm" :rules="rules" @submit.prevent v-on:submit.prevent>
			<HeaderPage>
				<el-button v-if="ruleForm.id" style="height: 44px; margin-left: 1rem" @click="syncProvider">Sincronizar</el-button>
				<el-button style="height: 44px; margin-left: 1rem" native-type="submit" @click.prevent="submitForm('ruleForm')">Salvar</el-button>
				<el-dropdown v-if="ruleForm.id" trigger="click" @command="handleAction">
					<el-button type="text" icon="el-icon-more" class="el-dropdown-link"></el-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="DESASSO">Desassociar</el-dropdown-item>
						<el-dropdown-item icon="el-icon-delete" divided command="DELETE">Excluir</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</HeaderPage>
			<el-card shadow="never">
				<el-row :gutter="20">
					<el-col :lg="12" :sm="12" :xs="24">
						<el-form-item prop="provider_id" label="Provider" :error="error.provider_id">
							<SearchProviders
								:model="ruleForm.provider_id"
								:isEdit="isEdit"
								@handleValue="
									(x) => {
										ruleForm.provider_id = x
									}
								"
							/>
						</el-form-item>
					</el-col>
					<el-col :lg="12" :sm="12" :xs="24">
						<el-form-item prop="department_store_id" label="Estabelecimento Comercial" :error="error.department_store_id">
							<SelectSearchDepartamentStore
								:disabled="$can('5')"
								:model="ruleForm.department_store_id"
								:isEdit="false"
								@handleValue="
									(x) => {
										$set(ruleForm, 'department_store_id', x)
									}
								"
							/>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :lg="12" :sm="12" :xs="24">
						<el-form-item prop="equipment_model_id" label="Modelo de Equipamentos" :error="error.equipment_model_id">
							<SelectSearchModeloEquipamento
								:model="ruleForm.equipment_model_id"
								:isEdit="isEdit"
								@handleValue="
									(x) => {
										ruleForm.equipment_model_id = x
									}
								"
							/>
						</el-form-item>
					</el-col>
					<el-col :lg="12" :sm="12" :xs="24">
						<el-form-item prop="equipment_id" label="Equipamento" :error="error.equipment_id">
							<SelectSearchEquipamento
								:model="ruleForm.equipment_id"
								:isEdit="isEdit"
								@handleValue="
									(x) => {
										ruleForm.equipment_id = x
									}
								"
							/>
						</el-form-item>
					</el-col>
				</el-row>
			</el-card>
		</el-form>
	</div>
</template>

<script>
	import HeaderPage from "@/app/components/HeaderPage"
	import { deleteEquipamentos, deleteTerminais, getTerminais, postDesassociarTerminais, postSyncProviderTerminais, postTerminais, putTerminais } from "@/app/domains/Records/services"
	import { clearRuleForm, makeErrorFilds, setFormData } from "@/app/plugins/utils"
	import SearchProviders from "@/app/components/Providers/SearchProviders"
	import SelectSearchModeloEquipamento from "@/app/components/ModeloEquipamento/SelectSearchModeloEquipamento"
	import SelectSearchDepartamentStore from "@/app/components/EstabelecimentoComercial/SelectSearchDepartamentStore"
	import SelectSearchEquipamento from "@/app/components/Equipamento/SelectSearchEquipamento"
	import { mapGetters } from "vuex"

	export default {
		name: "EditAddTerminal",
		components: {
			HeaderPage,
			SelectSearchDepartamentStore,
			SearchProviders,
			SelectSearchModeloEquipamento,
			SelectSearchEquipamento
		},
		data() {
			return {
				loadingPage: false,
				isEditEC: false,
				isPass: true,
				error: {},
				ruleForm: {
					provider_id: "",
					equipment_model_id: "",
					equipment_id: ""
				},
				rules: {
					equipment_id: [{ required: true, message: "Requerido", trigger: "blur" }],
					equipment_model_id: [{ required: true, message: "Requerido", trigger: "blur" }],
					department_store_id: [{ required: true, message: "Requerido", trigger: "blur" }],
					provider_id: [{ required: true, message: "Requerido", trigger: "blur" }]
				}
			}
		},
		methods: {
			async syncProvider() {
				this.loadingPage = true
				try {
					await postSyncProviderTerminais({ terminal_id: this.ruleForm.id, department_store_id: this.ruleForm.department_store_id, provider_id: this.ruleForm.provider_id })
					this.$message({
						showClose: true,
						message: "Sincronização feita.",
						type: "success"
					})
				} catch (e) {
					this.error = makeErrorFilds(e)
					this.$message({
						showClose: true,
						message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
						type: "error"
					})
				} finally {
					this.loadingPage = false
				}
			},
			submitForm(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						this.loadingPage = true
						this.error = {}
						try {
							if (this.ruleForm.id) {
								//Editando
								await putTerminais(this.ruleForm)
								this.$message({
									showClose: true,
									message: "Registro foi editado com sucesso.",
									type: "success"
								})
								await this.$router.push({ name: "records.terminal.index" })
							} else {
								// Adicionando
								await postTerminais(setFormData(this.ruleForm))
								this.$message({
									showClose: true,
									message: "Adicionado com sucesso",
									type: "success"
								})
								await this.$router.push({ name: "records.terminal.index" })
							}
						} catch (e) {
							this.error = makeErrorFilds(e)
							// this.$message({
							//   showClose: true,
							//   message: e.body.message,
							//   type: 'error'
							// })
						} finally {
							this.loadingPage = false
						}
					}
				})
			},
			async handleAction(act) {
				if (act === "DELETE") {
					this.loadingPage = true
					this.$confirm("Deseja realmente deletar este Terminal?", "Atenção", {
						confirmButtonText: "Sim",
						cancelButtonText: "Cancelar",
						center: true,
						type: "warning"
					})
						.then(async () => {
							try {
								await deleteTerminais(this.ruleForm.id)
								await this.$router.push({ name: "records.terminal.index" })
								this.$message({
									showClose: true,
									message: "Terminal foi deletado.",
									type: "success"
								})
							} catch (e) {
								this.$message({
									showClose: true,
									message: e.data,
									type: "error"
								})
							} finally {
								this.loadingPage = false
							}
						})
						.catch(() => {
							this.loadingPage = false
						})
				} else if (act === "DESASSO") {
					this.loadingPage = true
					this.$confirm("Deseja realmente Desassociar este Terminal?", "Atenção", {
						confirmButtonText: "Sim",
						cancelButtonText: "Não",
						center: true,
						type: "warning"
					})
						.then(async () => {
							try {
								let resTer = await postDesassociarTerminais({ serial_number: this.ruleForm.equipment.serial_number, id: this.ruleForm.id })
								if (resTer.error != undefined && resTer.error == true) {
									this.$message({
										showClose: true,
										message: resTer[0],
										type: "error"
									})
								} else {
									this.$message({
										showClose: true,
										message: "Terminal foi Desassociado.",
										type: "success"
									})
								}

								await this.$router.push({ name: "records.terminal.index" })
							} catch (e) {
								this.$message({
									showClose: true,
									message: e.data,
									type: "error"
								})
							} finally {
								this.loadingPage = false
							}
						})
						.catch(() => {
							this.loadingPage = false
						})
				}
			}
		},
		computed: {
			...mapGetters("Auth", ["currentUser"]),
			isEdit: function () {
				return !!this.ruleForm.id
			}
		},
		async beforeMount() {
			this.loadingPage = true
			try {
				if (this.$route.params.id) {
					let response = await getTerminais(`/${this.$route.params.id}`)

					this.ruleForm = clearRuleForm(response.data)
					delete this.ruleForm.department_store
					// delete this.ruleForm.equipment
					delete this.ruleForm.equipment_model
					delete this.ruleForm.provider
				} else {
					this.isEditEC = true
					if (this.$can("2|4|5")) {
						this.ruleForm.marketplace_id = this.currentUser.marketplace_id
					}
					if (this.$can("4")) {
						this.ruleForm.agent_id = this.currentUser.agent_id
					}
					if (this.$can("5")) {
						this.$set(this.ruleForm, "department_store_id", this.currentUser.department_store_id)
						this.ruleForm.department_store_id = this.currentUser.department_store_id

						this.$set(this.ruleForm, "marketplace_id", this.currentUser.department_store.marketplace_id)
						this.ruleForm.marketplace_id = this.currentUser.department_store.marketplace_id

						this.$set(this.ruleForm, "agent_id", this.currentUser.department_store.agent_id)
						this.ruleForm.agent_id = this.currentUser.department_store.agent_id
					}
				}
			} catch (e) {
				// await this.$router.push({name: 'records.users.index'})
				this.$message({
					showClose: true,
					message: e.data.data,
					type: "error"
				})
			} finally {
				this.loadingPage = false
			}
		}
	}
</script>

<style scoped></style>

